import React from "react";
import PropTypes from "prop-types";
import TooltipButton from "../../../ui/tooltip-button";
import SvgImage from "../../../../assets/svg/ic_btn_conciliacion.svg";

const BottomActions = ({ onClick }) => {
  return (
    <TooltipButton
      buttonClassName="bottom-actions"
      buttonTextClassName="action-text flama-basic"
      icon={<img className="action-image" src={SvgImage} alt="Button Action" />}
      onClick={onClick}
      buttonText="Añadir a propuesta de conciliación"
    />
  );
};

BottomActions.propTypes = {
  onClick: PropTypes.func
};

BottomActions.defaultProps = {
  onClick: () => {}
};
export default BottomActions;
